import React from 'react';
import { IconProps } from '../types';
const MinecraftChain: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="1" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(73, 80, 101, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(73, 80, 101, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(73, 80, 101, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(37, 44, 61, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(73, 80, 101, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(62, 68, 83, 255)" />
</svg>);
export default MinecraftChain;